import { render, staticRenderFns } from "./ModalLetter.vue?vue&type=template&id=5af3c972&"
import script from "./ModalLetter.vue?vue&type=script&lang=js&"
export * from "./ModalLetter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports